import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router-dom';

import { ErrorScreen } from './ErrorScreen';

/** React Router `errorElement` — surfaces both loader errors and render
 *  errors thrown anywhere inside the route subtree. */
export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();

  // Convert RouteErrorResponse (4xx/5xx loader errors) into a plain object
  // so ErrorScreen can format it.
  const normalised = isRouteErrorResponse(error)
    ? {
        status: error.status,
        statusText: error.statusText,
        data: error.data,
        message: `${error.status} ${error.statusText}`.trim(),
      }
    : error;

  return <ErrorScreen error={normalised} onRetry={() => navigate(0)} />;
}
